import React, { Component } from 'react';
import ReactTable from "react-table-6"
import "react-table-6/react-table.css";
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import Loader from 'react-loader-spinner';
window.teamMembers = [];
class Settings extends Component {
    constructor() {
        super();

        this.dialogClose = () => {
            this.setState({ hideupdateDialog: false, hideAddDialog: false, hideDeletePopup: false, });
        };

        this.settings = { effect: 'Zoom', duration: 400, delay: 0 };

        //for delete dialog component ok click
        this.buttons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,
               

            },
            'click': props => {
                this.deleteSupportTeamApi(this.state.propsId)
                this.setState({ disabled: false })

            }
        }
            , {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({ hideDeletePopup: false, disabled: false });
            }
        }];

        this.state = {
            showUploadFileModal: false,
            showCampaignModal: false,
            propsData: {},
            fileData: undefined,
            selectedTemplate: undefined,
            data: [],
            adminTeamMembers: [],
            disabled: false,
            emails: [],
            editedId: '-1',
            editImageSrc: './assets/images/edit.svg',
            contentEditable: "false",
            showStore: false,
            hidden: false,
            hideAddDialog: false,
            hideupdateDialog: false,
            hideDeletePopup: false,
            hideDeleteSuccessPopup: false,
            successResp: false,
            pageNum: null,
            pageNumForTransferLeads: null,
            disableSave: false,
            disableAdd: false,
            userName: "",
            showTransferLeadsPopUp: false,
            oldSalesExecId: null,
            mouseHover: false,
            newSalesExecId: null,
            newSalesExecEmailId: null,
            numberOfParams: 0

        }
        this.templateNames = [];
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.editImageSrc = "./assets/images/edit2.png";

    }
    notifyFailToCreate() {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>Oops! Error occurred. \n Please try again</b>, {
            position: "top-center",
            color: "red"

        });
    }

    notifyTransferStarted() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Leads transfer started</b>, {
            position: "top-center",
        });
    }

    notifyNoLeads() {
        toast.dismiss();
        toast(<b>No leads are allocated to this Sales Executive!</b>, {
            position: "top-center",
        });
    }

    viewLead = (props, e) => {

        var salesagentName = props.original;

        this.props.history.push({
            pathname: '/projectmgmt/view-leads',
            state: salesagentName

        })
    }
    addRow = () => {
        var teamController = this;
        if (teamController.state.pageNum != 0) {
            teamController.setState({ pageNum: 0 })
        }
        if (teamController.state.pageNumForTransferLeads != 0) {
            teamController.setState({ pageNumForTransferLeads: 0 })
        }
        var stateObj = this.state;
        stateObj.data.unshift({
            id: "",
            userEmail: "",
        });
        stateObj.contentEditable = true;
        this.state.disabled = true;
        this.setState(this.state);
    }

    notifyAddedData(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
        });
    }

    notifyFailedResponse(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"

        });
    }

    notifyFailedResponseForAdd(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"

        });
    }
    notifyFailedToAdd() {
        toast.dismiss();
        toast(<b>Oops! failed to add member</b>, {
            position: "top-center",
            color: "red"

        });
    }


    notifyFailedToUpdate() {
        toast.dismiss();
        toast(<b>Oops! failed to update</b>, {
            position: "top-center",
            color: "red"

        });
    }

    makeCelledit(props, e) {
        this.markAsBeingEdited(this.state.data[props.index].id, props);
    }

    markAsBeingEdited(id, props) {

        this.state.editedId = id;
        this.state.disableSave = false;
        var stateObj = this.state;
        this.setState(stateObj);

    }

    componentDidMount() {
        var settingController = this;
        setTimeout(() => {
            settingController.fetchTemplatesOfProject();
            settingController.fetchTeamDataApi();
            settingController.fetchSupportTeamDataApi();
        }, 300);

        document.addEventListener("projectChanged", function (event) {
            settingController.state.disabled = false;
            settingController.fetchTemplatesOfProject();
            settingController.projectId = event.projectId;
            settingController.fetchTeamDataApi(event.projectId);
            settingController.fetchSupportTeamDataApi(event.projectId);
        });
    }

    validateCells(userEmail) {
        var pattern = new RegExp(/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{1,5}|[0-9]{1,3})(\]?)$/);
        if ((userEmail == "")) {
            this.notifyEmptyFields();
            return false;
        } else if (!pattern.test(userEmail)) {
            this.notifyWarning("Please enter valid Email ID");
        } else {
            return true;
        }

    }

    notifyEmptyFields = () => {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill user email field</b>, {
            position: "top-center"
        });
    }

    notifyWarning(message) {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;{message}</b>, {
            position: "top-center"
        });
    }



    refreshData = (id) => {
        var refreshContent = this
        refreshContent = this.state.editedId = id;
        this.fetchSupportTeamDataApi()
        this.setState({ disabled: false })

    }

    fetchTeamDataApi = (projectId) => {
        var teamController = this;
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        $.ajax({
            url: "/api/project-membership-dev-team",
            async: false,
            method: 'GET',
            data: {
                projectId: projectId,

            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },

            success: function (res) {
                if (res.success === true) {
                    var resultData = res.result;
                    var data = resultData;

                    teamController.setState({
                        adminTeamMembers: data,
                        successResp: true,
                        disabled: false,
                    });
                    teamController.setState(teamController);
                    console.log("admin members", window.teamMembers)
                } else {
                    teamController.notifyFailToCreate();
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }

        });
    }



    fetchSupportTeamDataApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var teamController = this;
        $.ajax({
            url: "/api/project-membership-support-team",
            async: false,
            method: 'GET',
            data: {
                projectId: projectId,

            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                teamController.state.successResp = true;


                if (res.success === true) {
                    var responseData = res.result;
                    var adminTeamMembers = teamController.state.adminTeamMembers;
                    Array.prototype.push.apply(responseData, adminTeamMembers);

                    teamController.setState({
                        data: responseData,
                        disabled: false,
                    });
                    teamController.setState(teamController);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }

        });
    }
    handleEmailChange = (e) => {
        this.cursor = e.target.selectionStart;
        this.setState({ selectValue: e.target.value });
    }
    notifyAdded() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Added Successfully</b>, {
            position: "top-center",
        });
    }
    notifyUpdate() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Updated Successfully</b>, {
            position: "top-center",
        });
    }
    notifyUpdateNotPossible(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"

        });
    }
    notifyDelete() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Deleted Successfully</b>, {
            position: "top-center",
        });
    }
    onPageChange = (e) => {
        this.setState({ pageNum: e })
    }

    onPageChangeForTransferLeads = (e) => {
        this.setState({ pageNumForTransferLeads: e })
    }

    handleChangeUserName = (props, e) => {
        props.original.userName = e.target.value;
        props.original.userEmail = document.getElementById("userEmail" + props.index).innerText;
        this.setState(this.state);
    }
    notifyFileNotPresent(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center"
        });

    }

    uploadXlsHandle = (props, e) => {

        //To check if the xls is uploaded
        if ($('#uploadLeadDetailsXls')[0].files[0] == undefined) {
            this.notifyFileNotPresent("Please select Xls");
        } 

        //To check if the xls size is above the limit
        else if ($('#uploadLeadDetailsXls')[0].files[0].size >= 52428800) {
            this.notifyFileNotPresent("Size of the file exceeds its maximum permitted size of 52428800 bytes");
            this.state.faqAsXlsxButtonDiable = true;
            this.setState(this.state);
        } 
        
        else {
            var uploadXlsController = this;
            var formData = new FormData();
            formData.append("projectId", localStorage.getItem("currentProjectId"));
            formData.append("salesExecutiveId", props.original.userId);
            formData.append("leadName", props.original.userName);
            formData.append('document', $('#uploadLeadDetailsXls')[0].files[0]);

            $.ajax({
                url: '/salesdesk-api/upload-xlsx',
                type: 'POST',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                },
                data: formData,
                processData: false,
                contentType: false,
                success: function (data) {
                    if (data.success === true) {
                        uploadXlsController.notifySuccessToast("Your Xls uploaded successfully");

                    } else {
                        uploadXlsController.notifyErrorToast("Oops!something went wrong while uploading Xls");

                    }
                    uploadXlsController.setState({ showUploadFileModal: false});
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/platform/";
                    }
                }
            });

        }
    }
    notifySuccessToast(response) {
        toast.dismiss();
        toast(<b>
            <img src="./assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />
            &nbsp;&nbsp;{response}</b>, {
            position: "top-center"
        });
    }
    notifyErrorToast(response) {
        toast.dismiss();
        toast(<b>
            <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', width: "2rem", height: "2rem" }} content="" />
            &nbsp;&nbsp;{response}</b>, {
            position: "top-center"
        });
    }
    handleFile = (e) => {
        $('#uploadLeadDetailsXls')[0].files = e.target.files;
        console.log("the $('#uploadLeadDetailsXls')[0].files[0] is:" + $('#uploadLeadDetailsXls')[0].files[0]);
    }

    handleCampaignFile = (props, e) => {
       // $('#startCampaignXls' + props.original.id)[0].files = e.target.files;
       this.setState({ fileData: e.target.files[0]});
        // console.log("the $('#startCampaignXls')[0].files[0] is:" + $('#startCampaignXls' + props.original.id)[0].files[0]);
    }

    showTransferLeads = (props, e) => {

        var showLeadsController = this;
        showLeadsController.state.showTransferLeadsPopUp = true;
        showLeadsController.state.oldSalesExecId = props.original.userId;
        showLeadsController.setState(showLeadsController);
    }

    closeTransferLeadsPopUp = () => {
        this.setState({ showTransferLeadsPopUp: false })
    }

    transferLeadsApi = (props, e) => {
        var transferLeadsController = this;

        if (transferLeadsController.state.newSalesExecId != null) {

            $.ajax({
                url: "/salesdesk-api/transfer-leads",
                async: false,
                method: 'POST',
                data: {
                    projectId: localStorage.getItem('currentProjectId'),
                    oldSalesExecId: transferLeadsController.state.oldSalesExecId,
                    newSalesExecId: transferLeadsController.state.newSalesExecId,
                    newSalesExecEmailId: transferLeadsController.state.newSalesExecEmailId
                },
                headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },

                success: function (res) {
                    if (res.success === true) {
                        transferLeadsController.setState({ showTransferLeadsPopUp: false });
                        transferLeadsController.notifyTransferStarted();

                    } else {
                        transferLeadsController.setState({ showTransferLeadsPopUp: false });
                        transferLeadsController.notifyNoLeads();
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/platform/";
                    }
                }

            });
        } else {
            transferLeadsController.notifyErrorToast("Please select a sales executive");
        }
    }

    toggleHover = () => {
        var toggleController = this;
        toggleController.setState({ mouseHover: !toggleController.state.mouseHover })
    }

    onChecked = (e) => {
        var onCheckedController = this;

        onCheckedController.setState({
            newSalesExecId: e.currentTarget.name,
            newSalesExecEmailId: e.currentTarget.value,
        });
        // onCheckedController.setState({ newSalesExecId: props.original.userId, newSalesExecEmailId: props.original.userEmail})
    }

    startCampaign = (props, e) => {

        console.log( props.original);
        console.log( this.state.fileData);
        var userDetails = JSON.parse(localStorage.getItem("user_details"));
        //To check if the selected sales executive is a support user
        if(props.original.role != 'PROJECT_SUPPORT_USER') {
            this.notifyFileNotPresent("Leads can be assigned to Support Users only!");
        }

        //To check if a template is selected
        // else if ($('#loadTemplate' + props.original.id).val() == undefined) {
        //     this.notifyFileNotPresent("Please select a template");
        // }
        else if ( this.state.selectedTemplate == undefined) {
            this.notifyFileNotPresent("Please select a template");
        }

        //To check if the campaign file is uploaded
        else if ( this.state.fileData == undefined) {
            this.notifyFileNotPresent("Please select Xls");
        } 
        
        //To check if the campaign file's size exceeds the limit
        else if (this.state.fileData.size >= 52428800) {
            this.notifyFileNotPresent("Size of the file exceeds its maximum permitted size of 52428800 bytes");
            this.setState(this.state);
        } 
        
        else {
            this.notifySuccessToast("Upload Initiated...");

            var selectedTemplate = this.state.selectedTemplate;
            var importExportController = this;

            //Put Project Id, template name, email id of the logged in sales exec, campaign file and preferred sales exec user id in a FormData
            var formData = new FormData();
            formData.append("projectId", localStorage.getItem("currentProjectId"));
            formData.append("templateName", selectedTemplate);
            formData.append("emailId", userDetails.emailId);
            formData.append('campaignXlsxFile', this.state.fileData);
            formData.append('salesExecutiveId', props.original.userId);

            var uploadFaqAsXlsxTimer = setInterval(function () {
                clearTimeout(uploadFaqAsXlsxTimer);

                $.ajax({
                    url: '/salesdesk-api/upload-campaign-for-preferred-sales-exec',
                    type: 'POST',
                    headers: {
                        'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    },
                    data: formData,
                    processData: false,
                    contentType: false,
                    success: function (data) {
                        if (data.success === true) {
                            importExportController.notifySuccessToast("Campaign Leads Xlsx Uploaded successfully!");
                        } else {
                            importExportController.notifyErrorToast("Oops!something went wrong while uploading Xls");
                        }
                        importExportController.setState({ showCampaignModal: false});
                    },
                    error: function (xhr) {
                        if (xhr.status == 401) {
                            window.location.href = "/platform/";
                        }
                    }
                });
            }, 2000);
        }
    }

    fetchTemplatesOfProject = () => {

        var manageController = this;
        $.ajax({
            url: "/salesdesk-api/whatsapp/templates",
            async: false,
            method: 'GET',
            data: {
                projectId: localStorage.getItem('currentProjectId')
            },
            headers: {

                'Authorization': "Bearer " + localStorage.getItem("access_token")
            },
            success: function (res) {
                if (res.success === true) {
                    manageController.templateNames = [];

                    for (var i = 0; i < res.result.length; i++) {
                        manageController.templateNames[i] = (res.result[i].name);
                    }
                    manageController.setState({ selectedTemplate: res.result[0] ?  res.result[0].name : undefined });

                } else {
                    manageController.notifyError(res.result);
                }
            },
            error: function (xhr) {
                var errorMessage = xhr.status + ': ' + xhr.statusText
                if (xhr.status == 401) {
                    window.location.href = "/sales-desk/login";
                }
            }
        });
    }

    handleChangeOfTemplate = (props, event) => {
        props.original.name = event.target.value;
        this.setState({ selectedTemplate: event.target.value});
    }

    render() {
        const { data } = this.state

        // const { data2 } = this.state
        this.columns = [
            {
                Header: <b>Name</b>,
                textAlign: 'screenLeft',
                accessor: 'name',
                sortable: false,
                headerStyle: { marginLeft: '10px' },
                Cell: props => {
                    return (
                        <div name="userName">
                            <div className="textarea"
                                style={{
                                    background: 'white', height: '5%',
                                    resize: 'none', borderBottom: 'none', paddingLeft: '2px', paddingTop: '6px',
                                    border: (props.original.id == this.state.editedId || props.original.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == this.state.editedId || props.original.id == "") ? '2px' : 'none'
                                }}
                                id={"userName" + props.index}
                                class="form-control"
                                rows="1"
                                suppressContentEditableWarning
                                contentEditable={!((props.original.id != "") ? props.original.id != this.state.editedId : false)}
                            >
                                {props.original.userName}
                            </div>
                        </div>
                    )
                },
            },

            {
                Header: () => <b>User Email</b>,
                accessor: 'userEmail',
                sortable: false,
                headerStyle: { marginLeft: '10px', },
                Cell: props => (
                    <div name="userEmail">
                        <div className="textarea"
                            style={{
                                background: 'white', height: '5%',
                                resize: 'none', borderBottom: 'none', paddingLeft: '2px', paddingTop: '6px',
                                border: (props.original.id == this.state.editedId || props.original.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == this.state.editedId || props.original.id == "") ? '2px' : 'none'
                            }}
                            id={"userEmail" + props.index}
                            class="form-control"
                            rows="1"
                            suppressContentEditableWarning
                            contentEditable={!((props.original.id != "") ? props.original.id != this.state.editedId : false)}
                        >
                            {props.original.userEmail}
                        </div>
                    </div>
                )
            },

            {
                Header: <b>Action</b>,
                accessor: 'action',
                filterable: false,
                flexGrow: 1,
                 width: 600,
                sortable: false,
                headerStyle: { textAlign: 'center' },
                Cell: props => (
                    <div  style={{ display: "flex", width: "25rem"}}>
                        <div className="col-sm-5 btn-center" >
                            <button className='btn navyblue-btn' style={{  width: '8vw' }}
                                onClick={e => this.setState({ showUploadFileModal: true, propsData: props})}>Upload Leads
                                </button>
                        </div>
                        <div className="col-sm-5 btn-center">
                            <button className='btn navyblue-btn' style={{  width: '9vw' }}
                                onClick={e => this.setState({ showCampaignModal: true, propsData: props})}>Instant Campaign</button>
                        </div>
                        <div className="col-sm-5 btn-center">
                            <button className='btn navyblue-btn' style={{  width: '8vw' }}
                                onClick={e => this.viewLead(props, e)}>View Leads</button>
                        </div>
                        <div className="col-sm-4 btn-center">
                            <button className='btn navyblue-btn' style={{  width: '8vw' }}
                                onClick={e => this.showTransferLeads(props, e)}>Transfer Leads</button>
                        </div>
                    </div>

                ),

            },
        ]

        this.columns2 = [
            {
                Header: () => <b>Select the Sales Executive to transfer</b>,
                accessor: 'userEmail',
                sortable: false,
                headerStyle: { marginLeft: '10px', },
                Cell: props => (
                    <div name="userEmail">
                        <div className="textarea"
                            style={{
                                background: 'white', /*userSelect: 'none',*/ height: '5%', overflowY: 'auto',
                                resize: 'none', borderBottom: 'none', paddingLeft: '2px', paddingTop: '6px',
                                border: (props.original.id == this.state.editedId || props.original.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == this.state.editedId || props.original.id == "") ? '2px' : 'none'
                            }}
                            id={"userEmail" + props.index}
                            class="form-control"
                            rows="1"
                            suppressContentEditableWarning
                            contentEditable="false"
                        /*onClick={e => this.transferLeadsApi(props, e)}
                        onMouseEnter={this.toggleHover} onMouseLeave={this.toggleHover}*/
                        >
                            <div className="col-sm-2" >
                                <input
                                    type="radio"
                                    name={props.original.userId}
                                    value={props.original.userEmail}
                                    checked={this.state.newSalesExecEmailId === props.original.userEmail}
                                    onChange={this.onChecked}
                                    style={{ marginLeft: '2vw', height: '1vw', width: '2vw' }}

                                // checked={this.setState({
                                //     newSalesExecId: props.original.userId, newSalesExecEmailId: props.original.userEmail
                                // })
                                // }
                                // checked={e => this.onChecked(props, e)}
                                // onChange={this.onAddressChanged}
                                />
                            </div>
                            <div className='col-sm-4' style={{ fontSize: '1vw' }}>
                                {props.original.userEmail}
                            </div>
                        </div>
                    </div>
                )
            }
        ]


        return (
            <div><Loader
                type="TailSpin"
                color="#282a65"
                visible={(this.state.successResp) ? false : true}
                height={300}
                width={50}

                style={{ textAlign: 'center' }}
            />
                <div style={{ background: "#F9F9FB", display: this.state.successResp ? 'block' : 'none' }}>
                    <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                    <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                    <link href="assets/css/ej2-base.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                    <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                    <link href="assets/css/screenResolution.css" rel="stylesheet" />
                    <div className="wrapper" style={{ marginTop: "-20px" }}>

                    { this.state.showUploadFileModal && (
                        <div className='overlay'>
                        <div className='row row-modal' style={{ width: '42rem', height: "28rem", top: "25%", left: "30%"}}>
                        <div className='' style={{ marginRight: "15rem"}}>

                            <input type="file" id="uploadLeadDetailsXls"
                                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, .csv"
                                onChange={this.handleFile}
                                title="Choose Xls file"
                                style={{
                                    color: "black", marginTop: "47px", marginLeft: "11vw",
                                    
                                }} multiple /></div>
                        <div className=''
                         style={{ display: "flex", 
                         alignItems: "baseline", 
                         justifyContent: "flex-start",
                         gap: "10rem",
                         marginTop: "10rem",
                         width: "62%"       
                        }}
                        >

                        <button className="btn action-button"
                                onClick={e => this.setState({ showUploadFileModal: false})}>
                                Cancel   </button>

                            <button className="btn action-button"
                                onClick={e => this.uploadXlsHandle(this.state.propsData, e)}>
                                Upload Xls   </button>
                        </div>


                    </div>
                    </div>
                    )}

                    { this.state.showCampaignModal && ( 

                    <div className='overlay'>
                    <div className='row row-modal'>
                     <div className=''
                      
                      style={{ display: "flex", justifyContent: "center", alignItems: "center",
                      gap: "7px", padding: "54px"
                    }}
                     >
                            
                            <select className="input-group form-control select2 "
                                onChange={(e) => this.handleChangeOfTemplate(this.state.propsData, e)}
                                value={this.state.propsData.name}
                                id={"loadTemplate" + this.state.propsData.id}
                                style={{
                                    
                                    background: 'white', border: 'none',
                                   
                                    border: (this.state.propsData.id == undefined || this.state.propsData.id == this.state.editedId) ?
                                        '1px solid #D2D4DC' : 'none', borderRadius: (this.state.propsData.id == undefined) ? '8px' : 'none',
                                        width: "18rem",
                                        
                                }}
                            // disabled={(props.original.id == "") ? false : props.original.id != this.state.editedId}
                            >{this.templateNames.map(templates => (
                                <option key={templates} value={templates}>
                                    {templates}
                                </option>

                            ))}</select> 
                            <input type="file" id={"startCampaignXls" + this.state.propsData.id}
                                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, .csv"
                                onChange={e => this.handleCampaignFile(this.state.propsData, e)}
                                title="Choose Xls file"
                                style={{
                                    color: "black", marginLeft: "2vw",
                                    
                                }} multiple />
                        </div>
                       
                       

                       <div className=''  
                       
                       style={{ display: "flex", 
                       alignItems: "baseline", 
                       justifyContent: "flex-start",
                       gap: "10rem",
                       marginTop: "10rem",
                       width: "62%"       
                      }}
                       >
                          

                            <button className="btn action-button"
                                onClick={e => this.setState({ showCampaignModal: false})}>
                                Cancel   </button>

                                <button className="btn action-button" style={{ marginLeft: '5vw', marginTop: "1vw" }}
                                    onClick={e => this.startCampaign(this.state.propsData, e)}>
                                    Start Campaign   </button>
                           
                        </div>
                        </div>

                    </div>
                
                    )}

                        <div className="row" style={{ marginLeft: "2px", marginTop: '-15px' }}>
                            <div className="col-sm-5" >
                                <h6 className="nav-item" style={{ color: '#282a65', marginTop: '35px' }}>Sales Teams & Lead Assignments</h6>
                            </div>

                        </div>

                        <div className="content">
                            <div className="container-fluid">
                                <div className="row" style={{ marginTop: '1%' }}>
                                    <div className="col-lg-12 ">
                                        <div className="card">
                                            <ReactTable
                                                data={data}
                                                columns={this.columns}
                                                defaultPageSize={5}
                                                pageSizeOptions={[5, 10, 15]}
                                                onPageChange={this.onPageChange}
                                                page={this.state.pageNum}
                                            />
                                        </div>
                                        <ToastContainer className="Toast-at-center" />
                                        <DialogComponent width='400px' animationSettings={this.settings}
                                            header='Delete Confirmation' showCloseIcon={true} buttons={this.buttons}
                                            ref={dialog => this.dialogInstance = dialog}
                                            visible={this.state.hideDeletePopup} close={this.dialogClose}>
                                            <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                                                content="" />&nbsp;Do you want to delete the user ?<br />
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Note: Press 'Yes' to delete or press 'No' to decline.</DialogComponent>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="wrapper">
                    <div className="modal" style={{ display: this.state.showTransferLeadsPopUp ? 'block' : 'none' }}>
                        <div className="modal-dialog" id="center-aligned-account-modal">
                            <div className="modal-content" style={{ height: "auto", width: "750px" }}>
                                <div className="modal-header noBorder" style={{ height: '1px' }}>
                                    {/* <div className="errorMsg" style={{ color: 'red' }} name="response">{this.state.errors.response}</div> */}
                                    <button type="button" className="close" data-dismiss="modal" id="close_id" onClick={this.closeTransferLeadsPopUp}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24">
                                            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                            <path d="M0 0h24v24H0z" fill="none" />
                                        </svg>
                                    </button>
                                </div>
                                <div className="modal-body" style={{ height: '500px' }}>

                                    <ReactTable
                                        data={data}
                                        columns={this.columns2}
                                        /*defaultPageSize={10}
                                        pageSizeOptions={[5, 10]}
                                        onPageChange={this.onPageChangeForTransferLeads}
                                        page={this.state.pageNumForTransferLeads}*/
                                        showPagination={false}
                                        style={{ height: '400px' }}
                                    />
                                    <div className="modal-footer noBorder">
                                        <button type="button" className="btn btn-primary navyblue-btn mx-auto" data-dismiss="modal" onClick={this.transferLeadsApi}>Transfer</button>
                                        <button type="button" className="btn btn-primary navyblue-btn mx-auto" data-dismiss="modal" onClick={this.closeTransferLeadsPopUp}>Cancel</button>
                                    </div>




                                    {/* <form ref={(el) => this.myFormRef = el}>
                                        <div className="form-group row">
                                            <label className="col-sm-3 col-form-label">Old Password</label>
                                            <div className="col-sm-8">
                                                <input type="password" name="oldPassword" className="form-control-plaintext" onChange={this.handleChange} onBlur={this.validateOldPwd} />
                                            </div>
                                        </div>
                                        <div>
                                            <span className="errorMsg" style={{ color: 'red' }}>{this.state.errors.oldPassword}</span>
                                        </div> <br />
                                        <div className="form-group row">
                                            <label className="col-sm-3 col-form-label">New Password</label>
                                            <div className="col-sm-8">
                                                <input type="password" name="newPassword" className="form-control-plaintext" onBlur={this.validateNewPwd} onChange={this.handleChange} />
                                            </div>
                                        </div>
                                        <div>
                                            <span className="errorMsg" style={{ color: 'red' }}>{this.state.errors.newPassword} </span>
                                        </div> <br />
                                        <div className="form-group row">
                                            <label className="col-sm-3 col-form-label">Confirm Password</label>
                                            <div className="col-sm-8">
                                                <input type="password" name="confirmPassword" className="form-control-plaintext" onBlur={this.validateConfirmPwd} onChange={this.handleChange} />
                                            </div>
                                        </div>
                                        <div>
                                            <span className="errorMsg" style={{ color: 'red' }}>{this.state.errors.confirmPassword}</span>
                                        </div> <br />
                                        <div className="modal-footer noBorder">
                                            <button type="button" className="btn btn-primary navyblue-btn mx-auto" data-dismiss="modal" onClick={this.changePasswordApi}>Done</button>
                                        </div>
                                    </form> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div >



            </div>

        )
    }


}

export default Settings;


// WEBPACK FOOTER //
// ./src/sales-desk/projectmgmt/Settings.js